import React from 'react';

import EditIcon from '@mui/icons-material/Edit';
import { IconButton, useTheme } from '@mui/material';

interface PropsType {
	handleClick: () => void;
	size?: number;
}

function EditButton({ handleClick, size = 16 }: PropsType) {
	const theme = useTheme();
	return (
		<IconButton
			sx={{
				padding: '8px',
				borderRadius: '8px',
				background: theme.palette.warning.main,
			}}
			onClick={handleClick}
		>
			<EditIcon sx={{ fontSize: `${size}px`, color: theme.palette.warning.contrastText }} />
		</IconButton>
	);
}

export default EditButton;
